import { Handle, HandleProps, Position, useConnection } from "@xyflow/react"
import { cn } from "@/lib/utils"

interface TargetHandleProps extends Partial<HandleProps> {}

function TargetHandle(props: TargetHandleProps) {
  const connection = useConnection()
  return (
    // <Handle
    //   type="target"
    //   position={Position.Left}
    //   className={cn(
    //     "!size-2.5 !bg-red-500",
    //     // connection.inProgress ? "visible" : "invisible",
    //   )}
    //   {...props}
    // ></Handle>
    <Handle
      type="target"
      position={Position.Left}
      className={cn(
        "!left-0 !top-0 !h-full !w-full !transform !translate-x-0 !rounded-none !border-none !bg-transparent",
        connection.inProgress ? "visible" : "invisible",
      )}
      {...props}
    ></Handle>
  )
}

export default TargetHandle
